export default "__VITE_ASSET__D5UG4jLO__"